<template>
  <el-dialog
    title="Please enter organisation information"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="600px"
  >
    <OrganisationInformation ref="organisationInformation" :isSignIn="true" />
  </el-dialog>
</template>

<script>
import OrganisationInformation from '@/components/register/OrganisationInformation.vue'
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  components: {
    OrganisationInformation
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>
